import { render, staticRenderFns } from "./CourseTransferTab.vue?vue&type=template&id=bbacb654&scoped=true"
import script from "./CourseTransferTab.vue?vue&type=script&lang=js"
export * from "./CourseTransferTab.vue?vue&type=script&lang=js"
import style0 from "./CourseTransferTab.vue?vue&type=style&index=0&id=bbacb654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbacb654",
  null
  
)

export default component.exports